var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdTypeShop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 84,
    viewBox: "0 0 110 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56700_3365)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 84,
    rx: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9002 7.59302H89.0998C94.5554 7.59302 99.6594 12.0111 99.6594 18.1417V39.4382C99.8578 39.5082 100 39.6973 100 39.9195V54.0411C100 54.2634 99.8578 54.4524 99.6594 54.5225V139.894C99.6594 146.025 94.5554 150.443 89.0998 150.443H40.9002C35.4446 150.443 30.3406 146.025 30.3406 139.894V56.7343C30.1422 56.6642 30 56.4752 30 56.2529V48.0862C30 47.864 30.1422 47.6749 30.3406 47.6049V44.4843C30.1422 44.4142 30 44.2251 30 44.0029V35.8362C30 35.6139 30.1422 35.4249 30.3406 35.3548V31.2134C30.1422 31.1433 30 30.9542 30 30.732V26.4785C30 26.2563 30.1422 26.0672 30.3406 25.9971V18.1417C30.3406 12.0111 35.4446 7.59302 40.9002 7.59302Z",
    fill: "#A6C0EE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9003 8.27411H89.0998C94.5555 8.27411 98.9782 12.6922 98.9782 18.1422C98.9782 58.8705 98.9782 98.8355 98.9782 139.894C98.9782 145.344 94.5555 149.763 89.0998 149.763H40.9003C35.4447 149.763 31.022 145.344 31.022 139.894C31.022 98.4364 31.022 58.2843 31.022 18.1422C31.022 12.6922 35.4447 8.27411 40.9003 8.27411Z",
    fill: "url(#paint0_linear_56700_3365)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4296 12.9584C72.6691 12.9584 72.8633 12.7642 72.8633 12.5247C72.8633 12.2851 72.6691 12.0909 72.4296 12.0909C72.19 12.0909 71.9958 12.2851 71.9958 12.5247C71.9958 12.7642 72.19 12.9584 72.4296 12.9584Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4087 13.0865H61.8176C61.5083 13.0865 61.2559 12.8341 61.2559 12.5248C61.2559 12.2155 61.5083 11.9631 61.8176 11.9631H68.4087C68.718 11.9631 68.9704 12.2155 68.9704 12.5248C68.9704 12.8341 68.718 13.0865 68.4087 13.0865Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2106 18.1072C34.2035 18.2435 34.2 18.3807 34.2 18.5187V139.517C34.2 143.839 37.7076 147.343 42.0345 147.343H89.4851C93.812 147.343 97.3196 143.839 97.3196 139.517V18.5187C97.3196 18.5019 97.3196 18.485 97.3195 18.4681C97.2922 14.1692 93.7951 10.6927 89.4851 10.6927H80.1372C79.6022 10.6927 79.1296 11.0836 79.1296 11.7405C79.1296 11.9026 79.1228 12.6246 79.1092 12.7834C78.9482 14.6628 77.6533 15.8817 75.92 15.8817H55.5995C53.8982 15.8817 52.6084 14.7153 52.4192 12.8769C52.3998 12.6878 52.39 11.9345 52.39 11.7405C52.39 11.0836 51.9849 10.6927 51.3823 10.6927H42.0345C40.0823 10.6927 38.2968 11.406 36.925 12.5859C36.3966 13.0404 35.9295 13.5642 35.538 14.1431C34.7652 15.2858 34.2865 16.6433 34.2106 18.1072Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.5999,
    y: 17.3929,
    width: 60.2,
    height: 22.4,
    rx: 2.8,
    fill: "url(#paint1_linear_56700_3365)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.5999,
    y: 42.5929,
    width: 60.2,
    height: 22.4,
    rx: 2.8,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.5999,
    y: 67.7929,
    width: 60.2,
    height: 22.4,
    rx: 2.8,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5896 39.4661C61.5732 38.4277 60.5973 37.6731 59.5882 37.9185L38.8516 42.9604C37.5329 43.281 37.1701 44.9843 38.2437 45.8145L45.0666 51.0903L37.0441 61.4654L30.1276 56.1171C29.4202 55.5701 28.4033 55.7002 27.8563 56.4076L24.101 61.264C24.0983 61.2676 24.0955 61.2711 24.0928 61.2746L6.11685 84.5217C5.56985 85.2291 5.69988 86.2459 6.40727 86.7929L11.2745 90.5565C11.9819 91.1035 12.9988 90.9735 13.5458 90.2661L30.5312 68.3L37.4478 73.6483C38.1552 74.1953 39.172 74.0653 39.719 73.3579L43.4826 68.4907C43.4861 68.4863 43.4895 68.4818 43.4929 68.4773L52.4955 56.8348L59.3184 62.1106C60.392 62.9408 61.9493 62.1611 61.9278 60.8041L61.5896 39.4661Z",
    fill: "#413993"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 107,
    height: 81,
    rx: 1.5,
    stroke: "#413993",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_56700_3365",
    x1: 100.494,
    y1: -83.1229,
    x2: 44.409,
    y2: 196.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6C1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_56700_3365",
    x1: 35.5999,
    y1: 28.5929,
    x2: 95.7999,
    y2: 28.5929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6C1EE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56700_3365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 84,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdTypeShop);
export default __webpack_public_path__ + "static/media/adType_shop.f878e2b18e22f031fbc3eccb4b013a9e.svg";
export { ForwardRef as ReactComponent };